import { quantityBreakPricingStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityBreakPricing";
import getColor from "@insite/mobius/utilities/getColor";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(quantityBreakPricingStyles, {
    quantityBreakPricing: {
        viewLink: {
            css: css`
                font-size: ${TYPOGRAPHY.size.smallest};
                color: ${getColor("primary")};
                line-height: ${TYPOGRAPHY.lineHeight.small};
                ${contentSpacingStyles("0.3em", null)}
            `,
        },
    },
});
